import { Injectable } from '@angular/core'
import { BehaviorSubject, Observable } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class CanaryService {
  private canaryEnabled$ = new BehaviorSubject<boolean>(false)

  get isCanaryEnabled$(): Observable<boolean> {
    return this.canaryEnabled$.asObservable()
  }

  get isCanaryEnabled(): boolean {
    return this.canaryEnabled$.value
  }

  toggleCanary(): void {
    this.canaryEnabled$.next(!this.canaryEnabled$.value)
  }

  setCanary(enabled: boolean): void {
    this.canaryEnabled$.next(enabled)
  }
}
